'use strict';

const withRenderedMain = require('components-framework/view/with_rendered_main');
const trackingUtils = require('od-modules/utils/tracking.utils');
const BaseView = require('components-framework/view/base.view');
const {addBookingDataParameters} = require('../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/app_download_links.utils');

const APPLE = 'apple';
const ANDROID = 'android';
const TRACKING_KEYS = {
    ACTION: 'apps_download',
    LABELS: {
        APPLE: 'apps_open_market_apple',
        ANDROID: 'apps_open_market_android',
    },
};

module.exports = withRenderedMain(BaseView.extend({
    selectors: {
        linkFooter: '.footer_image_link',
    },

    events: {
        'tap .footer_image_link': 'linkFooterTrack',
    },

    linkFooterTrack(e) {
        e.preventDefault();
        const $eventTarget = $(e.currentTarget);

        this.trackEvent($eventTarget);
        if (this.options.bookingData && Odigeo.Utils.isMobile()) {
            const url = this.keys[$eventTarget.data('type') + 'ToAppTripdetailsUrl'];
            window.open(trackingUtils.decorateAppTouchpointUrl(addBookingDataParameters({baseUrl: url, bookingData: this.options.bookingData})));
        } else {
            window.open(trackingUtils.decorateAppTouchpointUrl($eventTarget.data('url')));
        }
    },

    trackEvent($eventTarget) {
        const label = Odigeo._.property($eventTarget.data('type'))({
            [APPLE]: TRACKING_KEYS.LABELS.APPLE,
            [ANDROID]: TRACKING_KEYS.LABELS.ANDROID,
        });
        const category = this.model.categoryItem ? this.model.categoryItem : $eventTarget.data('track-category');

        trackingUtils.trackEvent(TRACKING_KEYS.ACTION, label, category);
    },
}));
